import EnumClass, { build } from '../EnumClass';
import data, { QuizTypeId, QuizTypeData } from './data';
import * as Translations from './translations';

export class QuizType extends EnumClass<QuizTypeId, QuizTypeData> {
  public get getName() {
    return Translations.name[this.id];
  }
}

export const {
  list: QUIZ_TYPES,
  getById: getQuizTypeById,
  marshaller: QuizTypeMarshaller,
} = build<QuizTypeId, QuizTypeData, QuizType>('QuizTypeEnum', data, QuizType);
